<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Advertisement Display -->
          <div class="d-flex justify-center gap-3 flex-wrap">
            <div v-if="data.image.path">
              <div class="preview-container text-center my-3">
                <h6 style="color: #233076">
                  {{ $t("PLACEHOLDERS.advertisement") }}
                </h6>
                <video
                  v-if="
                    [
                      'mp4',
                      'mov',
                      'avi',
                      'wmv',
                      'flv',
                      'mkv',
                      'webm',
                      'm4v',
                    ].some((ext) => data.image.path.endsWith(ext))
                  "
                  :src="data.image.path"
                  controls
                  autoplay
                  loop
                  muted
                ></video>
                <img v-else :src="data.image.path" alt="Advertisement Image" />
              </div>
            </div>
          </div>
          <!-- End:: Advertisement Display -->
          <!-- Start:: Name Input Arabic -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Name Input Arabic -->

          <!-- Start:: Name Input English -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input English -->

          <!-- Start:: Link Type Display -->
          <base-input
            v-if="data.link_type"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.link_type')"
            :value="
              data.link_type === 'internal'
                ? $t('PLACEHOLDERS.internal_link') || 'رابط داخلي'
                : $t('PLACEHOLDERS.external_link') || 'رابط خارجي'
            "
            disabled
          />
          <!-- End:: Link Type Display -->

          <!-- Start:: External URL Display -->
          <base-input
            v-if="data.link_type === 'external' && data.external_url"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.external_url')"
            v-model.trim="data.external_url"
            disabled
          />
          <!-- End:: External URL Display -->

          <!-- Start:: Internal Link Fields Display -->
          <template v-if="data.link_type === 'internal'">
            <!-- Start:: Interface Type Display -->
            <base-input
              v-if="data.interface_type"
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.interface_type')"
              :value="
                data.interface_type === 'product'
                  ? $t('PLACEHOLDERS.product') || 'منتج'
                  : $t('PLACEHOLDERS.package') || 'باقة'
              "
              disabled
            />
            <!-- End:: Interface Type Display -->

            <!-- Start:: Item Display -->
            <base-input
              v-if="data.item_name"
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.item')"
              v-model.trim="data.item_name"
              disabled
            />
            <!-- End:: Item Display -->
          </template>
          <!-- End:: Internal Link Fields Display -->

          <!-- Start:: Start Date -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            disabled
          />
          <!-- End:: Start Date -->

          <!-- Start:: End Date -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            disabled
          />
          <!-- End:: End Date -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "ShowAds",
  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          type: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        link_type: null,
        external_url: null,
        interface_type: null,
        item_id: null,
        item_name: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {},

  methods: {
    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banners/${this.$route.params.id}`,
        });
        const responseData = res.data.data.banner;
        this.data.image.path = responseData?.image;
        this.data.nameAr = responseData?.title_ar;
        this.data.nameEn = responseData?.title_en;
        this.data.publish_start_date = responseData?.start_date;
        this.data.publish_end_date = responseData?.end_date;
        this.data.active = responseData?.is_active;
        this.data.link_type = responseData?.link_type;
        this.data.external_url = responseData?.external_url;
        this.data.interface_type = responseData?.interface_type;
        this.data.item_id = responseData?.model_id;

        // Get item name from model object if available
        if (responseData?.link_type === "internal" && responseData?.model) {
          this.data.item_name =
            responseData.model.name || responseData.model.name_ar;
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // Fetch product name
    async fetchProductName(productId) {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `products/${productId}`,
        });
        this.data.item_name = res.data.data.product.name;
      } catch (error) {
        console.log(error);
      }
    },

    // Fetch package name
    async fetchPackageName(packageId) {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `packages/${packageId}`,
        });
        this.data.item_name = res.data.data.package.name;
      } catch (error) {
        console.log(error);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
